import React, { FC, useEffect } from "react";
import { Router } from "@reach/router";
import { useDispatch, useSelector } from "react-redux";
import { LoginForm } from "./auth/loginForm";
import { authActions } from "./auth/auth.slice";
import { RootState } from "./store/rootReducer";
import { CardEditor } from "./cards/editor/cardEditor";
import { CardView } from "./cards/view/cardView";
import { SubcardStatistics } from "./cards/subcardStatistics/subcardStatistics";
import { AddCard } from "./cards/add/addCard";
import { QuickAdd } from "./cards/quickAdd/quickAdd";
import { Search } from "./cards/search/search";
import { Review } from "./review/review";
import { RouteComponentProps } from "@reach/router";
import { MarkupReference } from "./help/markupReference";
import { Memorize } from "./memorize/Memorize";
import { TrainTables } from "./train";
import { PracticeSubcards } from "./practice/practiceSubcards";
import { LlmLog } from "./llmLog/llmLog";
import { Car } from "./car/car";
import { CarVoices } from "./car/carVoices";

// Wrapper components to fix TypeScript errors with JSX elements
const LoginFormWrapper: FC<RouteComponentProps> = (props) => <LoginForm {...props} />;
const CardEditorWrapper: FC<RouteComponentProps> = (props) => <CardEditor {...props} />;
const CardViewWrapper: FC<RouteComponentProps> = (props) => <CardView {...props} />;
const SubcardStatisticsWrapper: FC<RouteComponentProps> = (props) => <SubcardStatistics {...props} />;
const AddCardWrapper: FC<RouteComponentProps> = (props) => <AddCard {...props} />;
const QuickAddWrapper: FC<RouteComponentProps> = (props) => <QuickAdd {...props} />;
const SearchWrapper: FC<RouteComponentProps> = (props) => <Search {...props} />;
const ReviewWrapper: FC<RouteComponentProps> = (props) => <Review {...props} />;
const MarkupReferenceWrapper: FC<RouteComponentProps> = (props) => <MarkupReference {...props} />;
const MemorizeWrapper: FC<RouteComponentProps> = (props) => <Memorize {...props} />;
const TrainTablesWrapper: FC<RouteComponentProps & { cardId?: string }> = (props) => <TrainTables {...props} />;
const PracticeSubcardsWrapper: FC<RouteComponentProps & { cardId?: string }> = (props) => <PracticeSubcards {...props} />;
const LlmLogWrapper: FC<RouteComponentProps> = (props) => <LlmLog {...props} />;
const CarWrapper: FC<RouteComponentProps> = (props) => <Car {...props} />;
const CarVoicesWrapper: FC<RouteComponentProps> = (props) => <CarVoices {...props} />;

const App: FC = () => {
    const dispatch = useDispatch();
    const status = useSelector((state: RootState) => state.auth.status);

    useEffect(() => {
        dispatch(authActions.loadSession());
    }, [dispatch]);

    if (status === 'unknown')
        return null;

    if (status === 'anonymous')
        return <LoginFormWrapper />;

    return (
        <Router>
            <CardEditorWrapper path="/edit/:cardId" />
            <CardViewWrapper path="/card/:cardId" />
            <SubcardStatisticsWrapper path="/card/:cardId/subcard/:subcardKey" />
            <AddCardWrapper path="/add" />
            <QuickAddWrapper path="/quick-add" />
            <SearchWrapper path="/search" />
            <MemorizeWrapper path="/memorize" />
            <MarkupReferenceWrapper path="/help/markup" />
            <TrainTablesWrapper path="/train/:cardId" />
            <PracticeSubcardsWrapper path="/practice/:cardId" />
            <LlmLogWrapper path="/llm-log" />
            <CarWrapper path="/car" />
            <CarVoicesWrapper path="/car/voices" />
            <ReviewWrapper path="/review/:cardId" />
            <ReviewWrapper default={true} />
        </Router>
    );
}

export default App;
